export { ContentBox } from './content-box';
export type { ContentBoxProps } from './content-box';
